import React from 'react';

import { faBars, faX } from '@fortawesome/free-solid-svg-icons';
import { styled } from '@mui/material/styles';
import classnames from 'classnames';
import { useMatchMedia } from '../../hooks/useMatchMedia';
import { Color } from '../../theme';
import { debounce } from '../../utils/debounce';
import Icon from '../components/Icon';
import Welcome from '../welcome/Welcome';
import { ClickAwayListener } from '@mui/material';


type Props = {
  className?: string;
};

const Navigation = styled(({ className }: Props) => {
  const isDesktopResolution = useMatchMedia('(min-width:992px)', true);
  const [menuOpen, setMenuOpen] = React.useState<boolean>(false);

  const [scrollPosition, setScrollPosition] = React.useState(0);
  const sticky = scrollPosition > 100;

  const handleScroll = debounce(() => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  }, 50);

  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleMenu = () => setMenuOpen((open) => !open);

  return (
    <header className={className}>
      <nav className={classnames({ sticky })}>
        <div className='row'>
          <img
            src='images/logo-white.png'
            alt='Coastal Ready Mix Logo'
            className='logo'
          />
          <img
            src='images/logo.png'
            alt='Coastal Ready Mix Logo'
            className='logo-black'
          />

          {!isDesktopResolution && (
            <button
              aria-label='navigation menu'
              style={{ backgroundColor: 'transparent', border: 'none' }}
              onClick={toggleMenu}
            >
              <Icon className='hamburger' icon={menuOpen ? faX : faBars} />
            </button>
          )}
          {(isDesktopResolution || menuOpen) && (
            <ClickAwayListener onClickAway={() => setMenuOpen(false)}>
              <ul
                className={classnames(
                  'nav',
                  isDesktopResolution ? 'main-nav' : 'mobile-nav'
                )}
              >
                <li>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href='#' onClick={toggleMenu}>
                    Home
                  </a>
                </li>
                <li>
                  <a href='#products' onClick={toggleMenu}>
                    Products
                  </a>
                </li>
                <li>
                  <a href='#about' onClick={toggleMenu}>
                    About
                  </a>
                </li>
                <li>
                  <a href='#contact' onClick={toggleMenu}>
                    Contact Us
                  </a>
                </li>
              </ul>
            </ClickAwayListener>
          )}
        </div>
      </nav>
      <Welcome />
    </header>
  );
}) <Props>`
  background-image: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.65)),
    url(images/mixer.jpeg);
  background-size: cover;
  min-height: 500px;
  height: 100vh;
  background-attachment: fixed;


  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    height: 100px;
    width: auto;
    float: left;
  }

  .logo-black {
    display: none;
    height: 100px;
    width: auto;
    float: left;
    margin: 5px 0;
  }

  /* nav */
  .nav {
    list-style: none;
  }

  .nav li a:link,
  .nav li a:visited {
    color: ${Color.white};
    font-size: 0.9rem;
    text-decoration: none;
    text-transform: uppercase;
    letter-spacing: 1px;
    word-spacing: 2px;
    border-bottom: 2px solid transparent;
    transition: border-bottom 0.2s;
    padding: 8px 0;
  }

  .nav li a:hover,
  .nav li a:active {
    border-bottom: 2px solid ${Color.red};
  }

  .hamburger {
    color: ${Color.white};
    font-size: 2rem;
  }

  /** main nav **/

  .main-nav li {
    display: inline-block;
    margin-left: 40px;
  }

  /** mobile nav **/
  .mobile-nav {
    z-index: 1;
    position: absolute;
    top: 100px;
    right: 8px;
    background-color: ${Color.grayDarkest};
    padding: 20px;
    border-radius: 8px;
  }

  .mobile-nav li {
    text-align: right;
    margin: 16px 0px;
  }

  .mobile-nav li a:link,
  .mobile-nav li a:visited {
    padding: 2px 0px;
  }

  /** sticky nav */

  .sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background-color: rgba(234, 234, 234, 0.95);
    box-shadow: 0 2px 2px ${Color.grayLight};
    z-index: 9999;
  }

  .sticky .hamburger {
    color: ${Color.black};
  }

  .sticky .main-nav li a:link,
  .sticky .main-nav li a:visited {
    color: ${Color.grayDarker};
    padding: 17px 0;
  }

  .sticky .main-nav li a:hover,
  .sticky .main-nav li a:active {
    border-bottom: 2px solid ${Color.red};
  }
  

  .sticky .logo {
    display: none;
  }

  .sticky .logo-black {
    display: block;
  }
`;

export default Navigation;
